import React from 'react';
import { ReferenceArrayInput, required, useTranslate } from 'react-admin';
import { AutocompleteArrayInput } from '../../../../base/components/ra/inputs';
import resourceSlug from '../../../../constant/resource-slug';

const LanguagesSelect = (props) => {
  const t = useTranslate();

  return (
    <ReferenceArrayInput
      source="languages"
      label="resources.brand.fields.languages"
      validate={required(t('ra.validation.required'))}
      fullWidth
      reference={resourceSlug.LANGUAGE}
      parse={(ids) =>
        ids?.map((id) => ({
          id,
        }))
      }
      format={(data) => data?.map((d) => d.id)}
      {...props}
    >
      <AutocompleteArrayInput optionText="name" />
    </ReferenceArrayInput>
  );
};

export default LanguagesSelect;
